// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.float-to-top {
  display: block;
  z-index: 3;
  opacity: 0.7;
  background-color: var(--ion-color-primary-contrast);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.float-to-top .container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.float-to-top .container ion-spinner {
  transform: scale(3);
}`, "",{"version":3,"sources":["webpack://./src/app/components/progressing/progressing.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,mDAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AACI;EACE,mBAAA;AACN","sourcesContent":[".float-to-top {\n  display: block;\n  z-index: 3;\n  opacity: 0.7;\n  background-color: var(--ion-color-primary-contrast);\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n\n  .container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n\n    ion-spinner {\n      transform: scale(3);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
